import React, { Suspense } from 'react'
import { useRoutes } from 'react-router-dom'
import PageonLoad from '@/components/pageonLoad'
import { useAppDispatch } from '@/store/hooks'
import routers from '@/router'

import { useEffect } from 'react';
import { message } from 'antd';
import eventEmitter from './eventEmitter';
import { setStudentLists, setStuId, setToken, setUid, setUserInfo } from '@/store/modules/authSlice'

import { ScrollToTop } from './hooks/ScrollToTop';
import intl, { locales } from '@/i18n/intl'; // 导入国际化配置







function App() {
  const dispatch = useAppDispatch();

  function setInitLogin(data: any) {
    console.log(data);
    dispatch(setToken(data.token))
    dispatch(setStuId(data.stuId))
    dispatch(setUid(data.customerId))
    dispatch(setStudentLists(data?.studentLists ||[]))
    dispatch(setUserInfo({
      customerId: data?.customerId,
      email: data?.email,
      headPic: data?.headPic,
      name: data?.name,
      nickName: data?.nickName,
      phone: data?.phone,
      phoneCode: data?.phoneCode,
    }))
  }

  useEffect(() => {
    const showMessage = (msg: any) => {
      message.error(msg);
    };

    eventEmitter.on('show-message', showMessage);

    return () => {
      eventEmitter.off('show-message', showMessage);
    };
  }, []);

  // pathname
  // console.log(window.location);
  const searchParams = new URLSearchParams(window.location.search);
  const param: any = searchParams.get('locales');
  let paramSingle: any = searchParams.get('Single');
  if (paramSingle) {
    paramSingle = JSON.parse(decodeURIComponent(paramSingle));
  }

  const currentLocale = param || window.localStorage.getItem('language') || 'in-YN'
  //  浏览器默认语言
  const defaultl: string = navigator.language.toLowerCase() || "";
  console.log(defaultl, 'defaultl浏览器默认语言');


  useEffect(() => {
    // 初始化国际化
    intl.init({
      currentLocale, // 设置默认语言
      locales,
    });

  }, [window.localStorage]);

  useEffect(() => {
    if (param) {
      if (paramSingle && Object.values(paramSingle).length > 0) {
        console.log(Object.values(paramSingle));
        setInitLogin(paramSingle);

      }
      window.localStorage.setItem('language', param)
      window.location.replace(window.location.pathname)
    }

  }, [intl.get('global.language')])

  return (
    <div className="tianwaa_app">
      <ScrollToTop />
      <Suspense >{useRoutes(routers)}</Suspense>
    </div>
  )
}

export default App
